import EditProfile from './edit-profile';

export default EditProfile;
